import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-trip-tab',
  templateUrl: './trip-tab.component.html',
  styleUrls: ['./trip-tab.component.scss']
})
export class TripTabComponent implements OnInit {

  constructor() { }
  @Input() isCabView: boolean = false;

  ngOnInit(): void {
  }

}
